export const GET_CONTACT_SETTINGS = 'GET_CONTACT_SETTINGS';
export const GET_CONTACT_SETTINGS_SUCCESS = 'GET_CONTACT_SETTINGS_SUCCESS';

export const SAVE_CONTACT_SETTINGS = 'SAVE_CONTACT_SETTINGS';
export const SAVE_CONTACT_SETTINGS_SUCCESS = 'SAVE_CONTACT_SETTINGS_SUCCESS';

export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING';

export const SETTINGS_ON_GET_CONTACT_REQUESTED = 'SETTINGS_ON_GET_CONTACT_REQUESTED';
export const SETTINGS_ON_GET_CONTACT_SUCCEEDED = 'SETTINGS_ON_GET_CONTACT_SUCCEEDED';
export const SETTINGS_ON_GET_CONTACT_FAILED = 'SETTINGS_ON_GET_CONTACT_FAILED';

export const SETTINGS_ON_SAVE_CONTACT_REQUESTED = 'SETTINGS_ON_SAVE_CONTACT_REQUESTED';
export const SETTINGS_ON_SAVE_CONTACT_SUCCEEDED = 'SETTINGS_ON_SAVE_CONTACT_SUCCEEDED';
export const SETTINGS_ON_SAVE_CONTACT_FAILED = 'SETTINGS_ON_SAVE_CONTACT_FAILED';

export const SEND_CONTACT_EMAIL_REQUESTED = 'SEND_CONTACT_EMAIL_REQUESTED';
export const SEND_CONTACT_EMAIL_SUCCEEDED = 'SEND_CONTACT_EMAIL_SUCCEEDED';
export const SEND_CONTACT_EMAIL_FAILED = 'SEND_CONTACT_EMAIL_FAILED';
export const RESET_CONTACT_STATUS = 'RESET_CONTACT_STATUS';
